import styled from 'styled-components';
import { getPaymentStateLabel } from '../utils/getPaymentStateLabel';

const StateChip = ({ value }) => {
    const normalizedValue = value?.replace(/_/g, ' ');

    const colorMap = {
        done: '#F9F5EC',
        cancel: '#F9F5EC',
        'A Autorizar': '#F5D0C6',
        draft: '#FBF0EA',
        'paid out': '#F9F5EC',
        paid: '#C1F0E3',
        'in payment': '#F9F5EC',
        posted: '#F9F5EC',
        sent: '#F9F5EC',
        check: '#F9F5EC',
        purchase: '#F9F5EC',
        confirmed: '#F9F5EC',
        'not paid': '#F9F5EC',
        partial: '#F9F5EC',
        reversed: '#F9F5EC',
    };

    const textColorMap = {
        done: '#DBC68F',
        cancel: '#DBC68F',
        draft: '#DBC68F',
        'paid out': '#DBC68F',
        'in payment': '#DBC68F',
        paid: '#28A986',
        posted: '#DBC68F',
        'A Autorizar': '#DE4921',
        sent: '#DBC68F',
        check: '#DBC68F',
        purchase: '#DBC68F',
        confirmed: '#DBC68F',
        'not paid': '#DBC68F',
        partial: '#DBC68F',
        reversed: '#DBC68F',
    };

    const label = getPaymentStateLabel(value);

    return (
        <Chip
            color={colorMap[normalizedValue]}
            textColor={textColorMap[normalizedValue]}
            title={label}
        >
            {label}
        </Chip>
    );
};

export default StateChip;

const Chip = styled.div`
    width: calc(100% - 2rem);
    max-width: 110px;
    padding: 0 1rem;
    height: 40px;
    color: ${(props) => props.textColor};
    background-color: ${(props) => props.color};
    display: flex;
    justify-content: center;
    align-items: center;
    border-radius: 10px;
    border: 1px solid ${(props) => props.textColor};
    font-size: 14px;
`;
